import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconMall"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM16 18.5V12.25C16 11.5596 15.4404 11 14.75 11H12.75V18.5H16ZM11.25 18.5V11H9.25C8.55964 11 8 11.5596 8 12.25V18.5H11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMall;
